import * as React from "react";

import { RecipeContextType } from "..";

export const RecipesContext = React.createContext<RecipeContextType>(null);
